// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditStaticPage-commonHeaderAdmin-Yntmt {
	position: fixed !important;
}

.EditStaticPage-adminLayout-ec8GC {
	padding-top: 64px !important;
}

.EditStaticPage-box-fAfIk h2 {
	font-size: 21px;
	font-weight: 600;
}

.EditStaticPage-exportLink-yFipV {
	margin-bottom: -29px;
}

.EditStaticPage-blockCenter-SxTpF {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.EditStaticPage-panelHeader-R3u5F {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.EditStaticPage-currencyselect-HtpgP {
	width: 100%;
	margin-right: 0px;
}

.EditStaticPage-panelHeader-R3u5F {
	overflow: hidden;
	position: relative;
}

.EditStaticPage-mar0-tE9En {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.EditStaticPage-blockCenter-SxTpF {
		padding: 0px;
	}

	.EditStaticPage-panelHeader-R3u5F {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.EditStaticPage-sideAdminPageWrapper-kvVuU {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.EditStaticPage-panelHeader-R3u5F {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.EditStaticPage-table-yeJaA {
	display: table;
}

.EditStaticPage-tableRow-CNzb7 {
	display: table-row;
}

.EditStaticPage-tableCell-TfVts {
	display: table-cell;
	float: none;
}

.EditStaticPage-formGroup-Tiyi9 {
	margin-bottom: 6px;
}

.EditStaticPage-select-iedx3 {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.EditStaticPage-noMargin-ABZp5 {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.EditStaticPage-exportLink-yFipV {
	padding-top: 10px;
	padding-right: 10px;
}

.EditStaticPage-labelTextNew-cGhn4 {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditStaticPage-displayInline-xKdlo {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.EditStaticPage-btnUPdate-MFSVL {
	display: inline-block;
}

.EditStaticPage-btnModalDelete-iFrvR {
	display: inline-block;
	margin-left: 15px;
}

.EditStaticPage-radioBtn-zrri8 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.EditStaticPage-backgroundImg-Lxktc {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.EditStaticPage-btnUPdate-MFSVL {
		display: block;
		margin-bottom: 12px;
	}

	.EditStaticPage-btnModalDelete-iFrvR {
		display: block;
		margin-left: 0px;
	}

	.EditStaticPage-btnWidth-HP4I2 {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.EditStaticPage-bannerImageBg-Hw0hh {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.EditStaticPage-bannerDelete-Vq8AL {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.EditStaticPage-modalRoot-FDXWL {
	padding: 32px;
}

.EditStaticPage-modalBorderBottom-miOeB {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.EditStaticPage-logInModalBody-Ggixy {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.EditStaticPage-exportSection-tZjUa {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.EditStaticPage-exportSectionGridSub-DJu6C {
	grid-template-columns: 50% 49% !important;
}

.EditStaticPage-exportText-ChuCb {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.EditStaticPage-exportLinkImg-N9WsV {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.EditStaticPage-vtrMiddle-Skmwo {
	vertical-align: middle;
}

.EditStaticPage-exportImg-CTOUt {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.EditStaticPage-profileViewlabel-c37s1 {
	display: inline-block;
	width: 38%
}

.EditStaticPage-profileViewMainContent-ze46e {
	display: inline-block;
	width: 62%;
}

.EditStaticPage-profileViewMain-GZbuH {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.EditStaticPage-profileViewInner-YQYQy {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.EditStaticPage-profileImageSection-rxvdz {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.EditStaticPage-lastviewInner-_vPXm {
	padding: 10px;
}

.EditStaticPage-whyHostHoriLine-R8Uve {
	margin: 30px 0;
}

.EditStaticPage-tableGrid-aLQn1 {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.EditStaticPage-headingContent-OyUpy {
	font-size: 18px;
	font-weight: 500;
}

.EditStaticPage-refundTextColor-C9xu_ {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.EditStaticPage-dividerLine-BN72K {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.EditStaticPage-smallContent-EX62V {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.EditStaticPage-sideAdminPageWrapper-kvVuU {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.EditStaticPage-sideAdminPageWrapper-kvVuU {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.EditStaticPage-exportSection-tZjUa {
		grid-template-columns: 100%;
	}

	.EditStaticPage-exportSectionGridSub-DJu6C {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.EditStaticPage-profileViewlabel-c37s1 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.EditStaticPage-profileViewMainContent-ze46e {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.EditStaticPage-ChangeToUpperCase-iVxlG {
	text-transform: uppercase
}

.EditStaticPage-noBorder-QFURI {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.EditStaticPage-siteAdminHeading-vHMym {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditStaticPage-siteAdminSubHeading-xr3Pn {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditStaticPage-adminFormDivider-MV1Oo {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.EditStaticPage-errorMessage-aTCZ3 {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.EditStaticPage-panelHeader-R3u5F {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.EditStaticPage-formGroup-Tiyi9 {
  margin-bottom: 6px;
}

.EditStaticPage-select-iedx3 {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.EditStaticPage-labelText-rU2Ti {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.EditStaticPage-space1-ERBwK {
	margin-bottom: 6px !important;
}

.EditStaticPage-space2-E1QA6 {
	margin-bottom: 12px !important;
}

.EditStaticPage-space3-VDYgY {
	margin-bottom: 18px !important;
}

.EditStaticPage-space4-uLwiU {
	margin-bottom: 24px !important;
}

.EditStaticPage-space5-K7soL {
	margin-bottom: 30px !important;
}

.EditStaticPage-space6-sr9h2 {
	margin-bottom: 36px !important;
}

.EditStaticPage-space7-vd_YR {
	margin-bottom: 42px !important;
}

.EditStaticPage-spaceTop8-Y664t {
	margin-bottom: 48px !important;
}

.EditStaticPage-spaceTop1-Iskon {
	margin-top: 6px !important;
}

.EditStaticPage-spaceTop2-AgoSk {
	margin-top: 12px !important;
}

.EditStaticPage-spaceTop3-WSi6m {
	margin-top: 18px !important;
}

.EditStaticPage-spaceTop4-WREmT {
	margin-top: 24px !important;
}

.EditStaticPage-spaceTop5-crg7j {
	margin-top: 30px !important;
}

.EditStaticPage-spaceTop6-DCnV9 {
	margin-top: 36px !important;
}

.EditStaticPage-spaceTop7-bdX3z {
	margin-top: 42px !important;
}

.EditStaticPage-spaceTop8-Y664t {
	margin-top: 48px !important;
}

.EditStaticPage-noMargin-ABZp5 {
	margin: 0px !important;
}

.EditStaticPage-padding1-tQKpt {
	padding-bottom: 6px !important;
}

.EditStaticPage-padding2-NvUdi {
	padding-bottom: 12px !important;
}

.EditStaticPage-padding3-LsBjD {
	padding-bottom: 18px !important;
}

.EditStaticPage-padding4-UNKeq {
	padding-bottom: 24px !important;
}

.EditStaticPage-padding5-zgmpz {
	padding-bottom: 30px !important;
}

.EditStaticPage-padding6-_wBLK {
	padding-bottom: 36px !important;
}

.EditStaticPage-padding7-tO7nS {
	padding-bottom: 42px !important;
}

.EditStaticPage-paddingTop1-p65f0 {
	padding-top: 6px !important;
}

.EditStaticPage-paddingTop2-HDaqi {
	padding-top: 12px !important;
}

.EditStaticPage-paddingTop3-Slejt {
	padding-top: 18px !important;
}

.EditStaticPage-paddingTop4-UDBww {
	padding-top: 24px !important;
}

.EditStaticPage-paddingTop5-ZrkMt {
	padding-top: 30px !important;
}

.EditStaticPage-paddingTop6-BBVMG {
	padding-top: 36px !important;
}

.EditStaticPage-paddingTop7-FzWmE {
	padding-top: 42px !important;
}

.EditStaticPage-noPadding-ZqDY_ {
	padding: 0px !important;
}

.EditStaticPage-textBold-c08Q4 {
	font-weight: 500 !important;
}

.EditStaticPage-textBolder-DlsfR {
	font-weight: 700 !important;
}

.EditStaticPage-textNormal-xIgyv {
	font-weight: normal !important;
}

.EditStaticPage-spaceBottom20-ER53e {
	margin-bottom: 20px;
}

.EditStaticPage-spaceBottom10-VHJte {
	margin-bottom: 10px;
}

.EditStaticPage-marginNone-k1SPE {
	margin: 0;
}

.EditStaticPage-spaceBottom15-CJlJp {
	margin-bottom: 15px;
}

.EditStaticPage-marginTopNone-QeAln {
	margin-top: 0;
}

.EditStaticPage-spaceTop11-bC__8 {
	margin-top: 11px;
}

.EditStaticPage-spaceTop21-m_la1 {
	margin-top: 21px;
}

.EditStaticPage-spaceTop20-bFfR2 {
	margin-top: 20px;
}

.EditStaticPage-spaceTop10-ON7Fk {
	margin-top: 10px;
}

/*New Design Text Colors */

.EditStaticPage-textDarkBlue-Cb32J {
	color: rgb(20, 39, 94) !important;
}

.EditStaticPage-textLightBlue-WZGqK {
	color: rgb(57, 87, 106) !important;
}

.EditStaticPage-textLightSandleGreen-SaqlD {
	color: rgb(76, 86, 41) !important;
}

.EditStaticPage-textLightBrown-SqdH9 {
	color: rgb(115, 79, 33) !important;
}

.EditStaticPage-textMediumMaroon-jfdPn {
	color: rgb(87, 37, 51) !important;
}

.EditStaticPage-textBrown-kOHt_ {
	color: rgb(160, 47, 24) !important;
}

.EditStaticPage-textMaroon-omgI_ {
	color: rgb(155, 49, 67) !important;
}

.EditStaticPage-textDarkBrown-Eh_t8 {
	color: rgb(83, 18, 16) !important;
}

.EditStaticPage-textMediumBrown-pU9wl {
	color: rgb(142, 28, 10) !important;
}

.EditStaticPage-textSkyBlue-aDhDY {
	color: rgb(37, 117, 141) !important;
}

.EditStaticPage-textGray-xDzmq {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `EditStaticPage-commonHeaderAdmin-Yntmt`,
	"adminLayout": `EditStaticPage-adminLayout-ec8GC`,
	"box": `EditStaticPage-box-fAfIk`,
	"exportLink": `EditStaticPage-exportLink-yFipV`,
	"blockCenter": `EditStaticPage-blockCenter-SxTpF`,
	"panelHeader": `EditStaticPage-panelHeader-R3u5F`,
	"currencyselect": `EditStaticPage-currencyselect-HtpgP`,
	"mar0": `EditStaticPage-mar0-tE9En`,
	"sideAdminPageWrapper": `EditStaticPage-sideAdminPageWrapper-kvVuU`,
	"table": `EditStaticPage-table-yeJaA`,
	"tableRow": `EditStaticPage-tableRow-CNzb7`,
	"tableCell": `EditStaticPage-tableCell-TfVts`,
	"formGroup": `EditStaticPage-formGroup-Tiyi9`,
	"select": `EditStaticPage-select-iedx3`,
	"noMargin": `EditStaticPage-noMargin-ABZp5`,
	"labelTextNew": `EditStaticPage-labelTextNew-cGhn4`,
	"displayInline": `EditStaticPage-displayInline-xKdlo`,
	"btnUPdate": `EditStaticPage-btnUPdate-MFSVL`,
	"btnModalDelete": `EditStaticPage-btnModalDelete-iFrvR`,
	"radioBtn": `EditStaticPage-radioBtn-zrri8`,
	"backgroundImg": `EditStaticPage-backgroundImg-Lxktc`,
	"btnWidth": `EditStaticPage-btnWidth-HP4I2`,
	"bannerImageBg": `EditStaticPage-bannerImageBg-Hw0hh`,
	"bannerDelete": `EditStaticPage-bannerDelete-Vq8AL`,
	"modalRoot": `EditStaticPage-modalRoot-FDXWL`,
	"modalBorderBottom": `EditStaticPage-modalBorderBottom-miOeB`,
	"logInModalBody": `EditStaticPage-logInModalBody-Ggixy`,
	"exportSection": `EditStaticPage-exportSection-tZjUa`,
	"exportSectionGridSub": `EditStaticPage-exportSectionGridSub-DJu6C`,
	"exportText": `EditStaticPage-exportText-ChuCb`,
	"exportLinkImg": `EditStaticPage-exportLinkImg-N9WsV`,
	"vtrMiddle": `EditStaticPage-vtrMiddle-Skmwo`,
	"exportImg": `EditStaticPage-exportImg-CTOUt`,
	"profileViewlabel": `EditStaticPage-profileViewlabel-c37s1`,
	"profileViewMainContent": `EditStaticPage-profileViewMainContent-ze46e`,
	"profileViewMain": `EditStaticPage-profileViewMain-GZbuH`,
	"profileViewInner": `EditStaticPage-profileViewInner-YQYQy`,
	"profileImageSection": `EditStaticPage-profileImageSection-rxvdz`,
	"lastviewInner": `EditStaticPage-lastviewInner-_vPXm`,
	"whyHostHoriLine": `EditStaticPage-whyHostHoriLine-R8Uve`,
	"tableGrid": `EditStaticPage-tableGrid-aLQn1`,
	"headingContent": `EditStaticPage-headingContent-OyUpy`,
	"refundTextColor": `EditStaticPage-refundTextColor-C9xu_`,
	"dividerLine": `EditStaticPage-dividerLine-BN72K`,
	"smallContent": `EditStaticPage-smallContent-EX62V`,
	"ChangeToUpperCase": `EditStaticPage-ChangeToUpperCase-iVxlG`,
	"noBorder": `EditStaticPage-noBorder-QFURI`,
	"siteAdminHeading": `EditStaticPage-siteAdminHeading-vHMym`,
	"siteAdminSubHeading": `EditStaticPage-siteAdminSubHeading-xr3Pn`,
	"adminFormDivider": `EditStaticPage-adminFormDivider-MV1Oo`,
	"errorMessage": `EditStaticPage-errorMessage-aTCZ3`,
	"labelText": `EditStaticPage-labelText-rU2Ti`,
	"space1": `EditStaticPage-space1-ERBwK`,
	"space2": `EditStaticPage-space2-E1QA6`,
	"space3": `EditStaticPage-space3-VDYgY`,
	"space4": `EditStaticPage-space4-uLwiU`,
	"space5": `EditStaticPage-space5-K7soL`,
	"space6": `EditStaticPage-space6-sr9h2`,
	"space7": `EditStaticPage-space7-vd_YR`,
	"spaceTop8": `EditStaticPage-spaceTop8-Y664t`,
	"spaceTop1": `EditStaticPage-spaceTop1-Iskon`,
	"spaceTop2": `EditStaticPage-spaceTop2-AgoSk`,
	"spaceTop3": `EditStaticPage-spaceTop3-WSi6m`,
	"spaceTop4": `EditStaticPage-spaceTop4-WREmT`,
	"spaceTop5": `EditStaticPage-spaceTop5-crg7j`,
	"spaceTop6": `EditStaticPage-spaceTop6-DCnV9`,
	"spaceTop7": `EditStaticPage-spaceTop7-bdX3z`,
	"padding1": `EditStaticPage-padding1-tQKpt`,
	"padding2": `EditStaticPage-padding2-NvUdi`,
	"padding3": `EditStaticPage-padding3-LsBjD`,
	"padding4": `EditStaticPage-padding4-UNKeq`,
	"padding5": `EditStaticPage-padding5-zgmpz`,
	"padding6": `EditStaticPage-padding6-_wBLK`,
	"padding7": `EditStaticPage-padding7-tO7nS`,
	"paddingTop1": `EditStaticPage-paddingTop1-p65f0`,
	"paddingTop2": `EditStaticPage-paddingTop2-HDaqi`,
	"paddingTop3": `EditStaticPage-paddingTop3-Slejt`,
	"paddingTop4": `EditStaticPage-paddingTop4-UDBww`,
	"paddingTop5": `EditStaticPage-paddingTop5-ZrkMt`,
	"paddingTop6": `EditStaticPage-paddingTop6-BBVMG`,
	"paddingTop7": `EditStaticPage-paddingTop7-FzWmE`,
	"noPadding": `EditStaticPage-noPadding-ZqDY_`,
	"textBold": `EditStaticPage-textBold-c08Q4`,
	"textBolder": `EditStaticPage-textBolder-DlsfR`,
	"textNormal": `EditStaticPage-textNormal-xIgyv`,
	"spaceBottom20": `EditStaticPage-spaceBottom20-ER53e`,
	"spaceBottom10": `EditStaticPage-spaceBottom10-VHJte`,
	"marginNone": `EditStaticPage-marginNone-k1SPE`,
	"spaceBottom15": `EditStaticPage-spaceBottom15-CJlJp`,
	"marginTopNone": `EditStaticPage-marginTopNone-QeAln`,
	"spaceTop11": `EditStaticPage-spaceTop11-bC__8`,
	"spaceTop21": `EditStaticPage-spaceTop21-m_la1`,
	"spaceTop20": `EditStaticPage-spaceTop20-bFfR2`,
	"spaceTop10": `EditStaticPage-spaceTop10-ON7Fk`,
	"textDarkBlue": `EditStaticPage-textDarkBlue-Cb32J`,
	"textLightBlue": `EditStaticPage-textLightBlue-WZGqK`,
	"textLightSandleGreen": `EditStaticPage-textLightSandleGreen-SaqlD`,
	"textLightBrown": `EditStaticPage-textLightBrown-SqdH9`,
	"textMediumMaroon": `EditStaticPage-textMediumMaroon-jfdPn`,
	"textBrown": `EditStaticPage-textBrown-kOHt_`,
	"textMaroon": `EditStaticPage-textMaroon-omgI_`,
	"textDarkBrown": `EditStaticPage-textDarkBrown-Eh_t8`,
	"textMediumBrown": `EditStaticPage-textMediumBrown-pU9wl`,
	"textSkyBlue": `EditStaticPage-textSkyBlue-aDhDY`,
	"textGray": `EditStaticPage-textGray-xDzmq`
};
module.exports = ___CSS_LOADER_EXPORT___;
